import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import { averageStatistics, space5 } from "../styled";
import { DeltaItem } from "../components/StatItem";
import { DOMAIN_SCORE_CONFIG } from "../assessmentConfig";
import { type AssessmentRecord } from "../types";

/**
 * The function `AverageScore` renders a section displaying assessment score averages for different
 * categories.
 * @component
 * @param props - The props object.
 * @param props.dataAssessments - The assessment data for the client
 * @return The `AverageScore` component to be rendered
 */
interface AverageScoreProps {
  dataAssessments: AssessmentRecord[];
}

function toNumberOrNull(value: string | number | null | undefined): number | null {
  return typeof value === "number" ? value : null;
}

export default function AverageScore({ dataAssessments }: AverageScoreProps) {
  // dataAssessments is passed in chronological order (oldest → newest).
  // Use the last two entries so the delta compares the most recent vs previous.
  const assessment = dataAssessments[dataAssessments.length - 1];
  const prevAssessment = dataAssessments[dataAssessments.length - 2];

  return (
    <Box component="section" sx={averageStatistics}>
      <Grid container rowSpacing={space5} columnSpacing={space5}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">Assessment score averages</Typography>
        </Grid>

        {DOMAIN_SCORE_CONFIG.map((score) => (
          <Grid key={score.key} item xs={2}>
            <DeltaItem
              label={score.label}
              currentValue={toNumberOrNull(assessment.data[score.key])}
              previousValue={toNumberOrNull(prevAssessment?.data[score.key])}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
